import { BaseButton } from '@/app/components/buttons/BaseButton';
import { SingleDatePicker } from '@/app/components/form/SingleDatePicker';
import type { SingleDatePickerProps } from '@/app/components/form/SingleDatePicker/types';
import CalendarIcon from '/public/icons/calendar.svg';

interface DateInputWithFooterProps extends SingleDatePickerProps {
  label: string;
  name: string;
  value: string;
  onChangeDate: (date: string) => void;
  required?: boolean;
  minDate?: Date;
  maxDate?: Date;
  dateFormat?: string;
}

export const DateInputWithFooter = ({
  label,
  name,
  value,
  onChangeDate,
  required,
  minDate,
  maxDate,
  dateFormat,
  ...props
}: DateInputWithFooterProps) => {
  const onConfirm = (onClose?: () => void) => () => {
    onChangeDate(value);
    onClose?.();
  };

  return (
    <SingleDatePicker
      label={label}
      name={name}
      value={value}
      required={required}
      minDate={minDate}
      maxDate={maxDate}
      dateFormat={dateFormat}
      shouldCloseOnSelect={false}
      onChangeDate={onChangeDate}
      startIcon={<CalendarIcon className="w-6 h-6 text-neutral-700" />}
      renderCustomFooter={({ onClose, onClear }) => {
        return (
          <div className="flex justify-end gap-3 py-[16px] px-[16px] border-t border-gray-200">
            <BaseButton intent="secondary" onClick={onClear} size="full">
              Cancel
            </BaseButton>
            <BaseButton intent="primary" onClick={onConfirm(onClose)} size="full">
              Confirm
            </BaseButton>
          </div>
        );
      }}
      {...props}
    />
  );
};
